/**
 * Created by Languagenut on 18/06/2019.
 */

import React  from 'react';
import {Button , ButtonGroup , Col, Row, Navbar, Nav, ProgressBar} from 'react-bootstrap'


import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search , CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Translation from '../store/internationalization-store.js';

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

export default class GeneralTable extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.selectionIndex = 0;
        this.state = {
            columns:this.formatCells(),
            searched:false,
            selectionIndex:0
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.selectionIndex = 0;
        this.setState({
            columns:this.formatCells(),
            update:true,
            isFirstSelection:this.isFirstSelection(),
            isLastSelection:this.isLastSelection()
        });
    }

    formatCells(){
        if (this.props.maxColumnLimit != undefined) {
            if (this.props.startColumn != undefined) {
                var pageSize = this.props.maxColumnLimit - this.props.startColumn
                return this.props.columns.slice(0, this.props.startColumn).concat(
                    this.props.columns.slice(this.props.startColumn + 
                    (this.selectionIndex*pageSize),this.props.startColumn + 
                    (this.selectionIndex*pageSize) + pageSize));
            } else {
                return this.props.columns.slice(this.selectionIndex*this.props.maxColumnLimit, 
                    (this.selectionIndex*this.props.maxColumnLimit)+this.props.maxColumnLimit);
            }
        } else {
            return this.props.columns;
        }
    };

    isFirstSelection(){
        return this.selectionIndex == 0;
    };

    isLastSelection(){
        if (this.state.columns != undefined && this.props.maxColumnLimit != undefined) {
            return (this.props.columns.length - this.props.startColumn) <= ((this.selectionIndex+1)*(this.props.maxColumnLimit-this.props.startColumn))
        } else {
            return true;
        }
    };

    onShift(offest){
        this.selectionIndex += offest;

        this.setState({
            isFirstSelection:this.isFirstSelection(),
            isLastSelection:this.isLastSelection(),
            columns:this.formatCells(),
        });
    }

    render(){

        let data = this.props.data || [];
        var pageSize = 10;
        if (this.props.pageSize != undefined) {
            pageSize = this.props.pageSize;
        }
        const paginationOption = {
            hideSizePerPage: true,
            sizePerPage:this.props.limit || 40,
        };   

        let self = this;
        var columnNavigation = "";
        if (this.props.maxColumnLimit != undefined) {
            columnNavigation = <Nav.Item><div style={{marginTop:'-8px'}}><ButtonGroup className="float-right">
                <Button disabled={this.isFirstSelection()} onClick={this.onShift.bind(this , -1)}><i class="fas fa-arrow-left"></i></Button>
                <Button disabled={this.isLastSelection()} onClick={this.onShift.bind(this , 1)}><i class="fas fa-arrow-right"></i></Button>
            </ButtonGroup></div></Nav.Item>
        }

        data = self.props.isLoading ? [] : data

        var filename = this.props.fileName;
        if (filename == undefined) {
            filename = "downloaded_data"
        }

        return <div>
            
            <ToolkitProvider
                keyField={this.props.key || 'id'}
                data={ data }
                id="my-table"
                columns={ !self.props.isLoading ? (this.state.columns || [{}]) : [{}] }
                search={ { searchFormatted: true } }
                bordered={this.props.bordered || false}
                rowClasses={ this.props.rowClasses }
                exportCSV={{
                    fileName: filename+'.csv' ||Translation.get(-1 , 'download.csv')
                }}
                >
                {
                        props => (
                        <div>
                            <div className={self.props.noSearch ? "hide" : "float-left"}>
                                <Row className="align-items-center">
                                    <Col md={12}>
                                        <Navbar style={{padding:0}}>

                                            <Nav.Item className={this.props.hideSearch ? "hide" : ""} style={{display:"inline-flex"}}>
                                                <SearchBar style={{marginTop:"0px"}} delay={1000} placeholder={Translation.get(595 , 'Search')} { ...props.searchProps } />
                                                {this.props.searchExtra}
                                            </Nav.Item>
                                            &nbsp;
                                            <ExportCSVButton {...props.csvProps} className={this.props.hideDownload ? "hide" : "btn-primary"} style={{marginTop:'-8px'}}>
                                                    {Translation.get(826 , 'Download')}</ExportCSVButton>
                                            &nbsp;
                                            <Nav.Item>
                                                {self.props.navigation}
                                            </Nav.Item>

                                            <Nav.Item>
                                            {self.props.secondary}
                                            </Nav.Item>
                                        </Navbar>
                                    </Col>
                                </Row>
                            </div>
                            <div className="float-right">{columnNavigation} {self.props.component}</div>


                            {!self.props.isLoading ? <BootstrapTable
                                defaultSorted = {this.props.defaultSorted}
                                bordered={ !self.props.noBoarder }
                                pagination={ data.length <= (self.props.limit || 40) ?  false : paginationFactory(paginationOption) }
                                { ...props.baseProps }
                                /> : <table class="table table-bordered"></table> }



                        </div>
                    )
                }
            </ToolkitProvider>
            <div>{self.props.isLoading ? <ProgressBar animated now={45} /> : null }</div>
        </div>

    }

}